import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-single-text-input-modal',
  templateUrl: './single-text-input-modal.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class SingleTextInputModalComponent implements OnInit {

  onClose: Subject<any>;

  @Input() modalTitle : string;
  @Input() inputLabel: string;

  @Input() inputText: string;
  @Input() isCalculationName: boolean;
  readonly forbiddenSubstringName = TabsService.SEPARATOR;

  constructor(public bsModalRef : BsModalRef) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  close(){
    this.bsModalRef.hide();
  }

  ok(){
    this.onClose.next(this.inputText);
    this.bsModalRef.hide();
  }
}
